import axios from "axios";

// Create axios instance
export const authAxios = axios.create({
	baseURL: import.meta.env.VITE_REACT_SERVER_BASE_URL,

	withCredentials: true,
	headers: {
		"Content-Type": "application/json",
	},
});

// Add an interceptor to dynamically include the token
authAxios.interceptors.request.use(config => {
	const token = localStorage.getItem("accessToken");
	if (token) {
		config.headers.Authorization = `Bearer ${token}`;
	}
	return config;
}, error => Promise.reject(error));
